import React, { Component } from 'react';

class getTimer extends Component {

componentWillUnmount () {
   clearInterval(this.timer)
 }
 tick () {
   //this.setState({count: (this.state.count + 1)})
   console.log("actualizar cuenta");
   this.props.actualizar_cuentas();
 }
 startTimer () {
   clearInterval(this.timer)
   this.timer = setInterval(this.tick.bind(this), 10000)
 }
 stopTimer () {
   clearInterval(this.timer)
 }
 render () {
   return (
     <React.Fragment>
     </React.Fragment>
   )
 }
 componentDidUpdate (){
  this.startTimer ();
 }
}
 export default getTimer;
